import { Selector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as store from 'src/store';

const useStoreSelector = <A>(selector: Selector<store.types.State, A>): A => useSelector(selector);

export default useStoreSelector;
